import React from "react"
import { Box, Grid, Container, Link } from "@theme-ui/components"
import { InboundLink } from "./link"
import { getPagePath } from "../utils/path"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"

const CtaCollection = ({ block }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale

  return (
    <Container sx={{ padding: ["16px", "16px", 0, 0], my: [6, 6, 8, 8] }}>
      <Grid columns={[1, null, 2]} gap={4}>
        {block.cta.map((item, index) => (
          <Box
            key={index}
            sx={{
              h3: {
                wordBreak: "break-word",
                lineHeight: 0.9,
                textTransform: "uppercase",
                color: "dark",

                my: [5, 5, 3, 4],
                fontSize: [5, 5, 6, 6],
                "& > em": {
                  color: "primary",
                  fontStyle: "normal",
                },
              },
              a: {
                fontFamily: "mono",
                backgroundColor: "primary",
                borderRadius: "40px",
                color: "white",
                textTransform: "uppercase",
                fontWeight: 400,
                fontSize: [2, 2, 2, "15px"],
                p: 3,
                textDecoration: "none",
                px: 4,
                display: "inline-block", // Assicura che il link sia centrato e abbia spaziatura
                ":hover": {
                  backgroundColor: "secondary",
                },
              },
            }}
          >
            <Box dangerouslySetInnerHTML={{ __html: item.subtitle }} />
            {item.link ? (
              <InboundLink to={getPagePath(item.link.link, locale)}>
                {item.link.anchor}
              </InboundLink>
            ) : (
              <a href="mailto:innovation@diginnova.it">Scrivici</a>
            )}
          </Box>
        ))}
      </Grid>
    </Container>
  )
}

export default CtaCollection
